import ApiService from "./ApiService";

const MaterialService = {
  GetMaterialsByJobId: async (jobId: string): Promise<any> => {
    return ApiService.Get(`jobs/${jobId}/materials`);
  },

  AddMaterial: async (jobId: string, body: any): Promise<any> => {
    return ApiService.Post(`jobs/${jobId}/materials`, body);
  },

  // Replace the job's material totals with the full desired per-product list (idempotent).
  SyncMaterials: async (jobId: string, body: any): Promise<any> => {
    return ApiService.Update(null, `jobs/${jobId}/materials`, body);
  },

  UpdateMaterial: async (id: string, body: any): Promise<any> => {
    return ApiService.Patch(`materials/${id}`, body);
  },

  RemoveMaterial: async (id: string): Promise<any> => {
    return ApiService.Delete(id, "materials");
  },
};

export default MaterialService;
